import { render } from "./AboutUsView.vue?vue&type=template&id=3078d7d0&ts=true"
import script from "./AboutUsView.vue?vue&type=script&lang=ts"
export * from "./AboutUsView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__